import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { reportNoShow } from 'modules/accommodations/features/reservations/api';

export const useMutationReportNoShow = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();

  return useMutation(reportNoShow, {
    onSuccess: data => {
      if (data.success) successToast(t('No show successfully reported'));
    },
    onError: () => errorToast(),
  });
};
